import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { IntlProvider } from 'react-intl';
import { MuiThemeProvider } from '@material-ui/core';
import { SnackbarProvider } from './contexts/Snackbar';
import { DialogsProvider } from './contexts/Dialog';
import { EventTrackerProvider } from './contexts/EventTracker';
import { GoogleProvider } from './contexts/Google';
import { DashboardAnalyticsProvider } from './contexts/DashboardAnalytics';
import * as serviceWorker from './serviceWorker';
import App from './app';
import DateFnsUtils from '@date-io/date-fns';
import CssBaseline from '@material-ui/core/CssBaseline';
import SideBarProvider from './contexts/SideBar';
import NotificationsProvider from './contexts/Notifications';
import OnboardingProvider from './contexts/Onboarding';
import OnboardingV2Provider from './contexts/GetStarted';
import CompanyContextProvider from './contexts/Company';
import AuthContextProvider from './contexts/Auth';
import messages from './messages-old';
import SetFavicon from './components/SetFavicon';
import themeCBB from './themes/CBB/theme';
import themeBerkeley from './themes/BRK/themeBerkeley';
import theme8Data from './themes/8DATA/theme';
import companyInfo, { AppTheme } from './themes/themes';
import { ABTestingProvider } from '@8fig/ab-testing';
import { features } from './ab-testing.json';

const theme = process.env.REACT_APP_THEME;

let companyTheme = themeCBB;
switch (theme) {
  case AppTheme.BRK:
    companyTheme = themeBerkeley;
    break;
  case AppTheme['8DATA']:
    companyTheme = theme8Data;
    break;
  default:
    companyTheme = themeCBB;
}
document.title = companyInfo[theme].company;

ReactDOM.render(
  <BrowserRouter>
    <SetFavicon />
    <MuiThemeProvider theme={companyTheme}>
      <IntlProvider locale="en" messages={messages}>
        <AuthContextProvider>
          <ABTestingProvider features={features} facts={{}}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <SnackbarProvider>
                <DialogsProvider
                  onboardingComplete={false}
                  onboardingCompletedPreQualifySteps={false}
                  newLine={false}
                  editLine={false}
                  upload={false}
                  drillDown={false}
                  forgotPassword={true}
                  thanks={false}
                  deleteLine={false}
                  bulkDelete={false}
                  autoCreateLines={false}
                  duplicateLine={false}
                  contractConfirmation={false}
                  contractAddendum={false}
                  paymentsModal={false}
                  activateLines={false}
                  onboardingSuccess={false}
                  chooseBankOption={false}
                  selectBankAccount={false}
                  deleteBank={false}
                  connectAmazonSeller={false}
                  addProduct={false}
                  help={false}
                  applicationSubmitted={false}
                  planDiscovery={false}
                  deletePlan={false}
                  rejectEditedPlan={false}
                  stockOnHand={false}
                  skipConnectAmazon={false}
                  proposeAlternativePlan={false}
                  switchShop={false}
                >
                  <SideBarProvider>
                    <CompanyContextProvider>
                      <EventTrackerProvider>
                        <NotificationsProvider>
                          <OnboardingV2Provider>
                            <OnboardingProvider>
                              <GoogleProvider>
                                <DashboardAnalyticsProvider>
                                  <CssBaseline />
                                  <App />
                                </DashboardAnalyticsProvider>
                              </GoogleProvider>
                            </OnboardingProvider>
                          </OnboardingV2Provider>
                        </NotificationsProvider>
                      </EventTrackerProvider>
                    </CompanyContextProvider>
                  </SideBarProvider>
                </DialogsProvider>
              </SnackbarProvider>
            </MuiPickersUtilsProvider>
          </ABTestingProvider>
        </AuthContextProvider>
      </IntlProvider>
    </MuiThemeProvider>
  </BrowserRouter>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
